/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  if (window.__slideshowInitDone) return;
  window.__slideshowInitDone = true;

  const runIdle = window.requestIdleCallback || function (cb) { setTimeout(cb, 0); };

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-section-type="slideshow"]');

    if (!sections.length || typeof Flickity === 'undefined') return;

    sections.forEach(section => {
      runIdle(() => {
        const container = section.querySelector('.slideshow');
        if (!container) return;

        const settingsAttr = section.getAttribute('data-section-settings');
        let settings = {};

        try {
          settings = JSON.parse(settingsAttr);
        } catch (e) {
          console.warn('Invalid slideshow settings JSON:', e);
          return;
        }

        const images = container.querySelectorAll('img');
        let loaded = 0;

        if (images.length === 0) {
          return init(container, settings);
        }

        images.forEach(img => {
          if (img.complete) {
            loaded++;
            if (loaded === images.length) init(container, settings);
          } else {
            img.addEventListener('load', () => {
              loaded++;
              if (loaded === images.length) init(container, settings);
            });
          }
        });
      });
    });

    function init(container, settings) {
      requestAnimationFrame(() => {
        new Flickity(container, {
          wrapAround: true,
          autoPlay: settings.autoPlay ? settings.cycleSpeed : false,
          prevNextButtons: settings.prevNextButtons,
          pageDots: settings.pageDots,
          setGallerySize: settings.setGallerySize,
          adaptiveHeight: settings.adaptiveHeight,
          selectedAttraction: 0.02,
          friction: 0.6
        });
      });
    }
  });
})();


/**
 * Lightweight Accordion Script for Shopify
 * ------------------------------------------------
 * Runs only on product/blog pages when `.accordion-section` is present.
 * Handles accessible accordion behavior and re-initializes on:
 * - Variant changes (form input/change events)
 * - Dynamic content updates (MutationObserver)
 */

window.initAccordion = function () {
  const containers = document.querySelectorAll('.accordion-section');
  if (!containers.length) return;

  containers.forEach(container => {
    const titles = container.querySelectorAll('.accordion-title');
    titles.forEach(title => {
      if (title.dataset.accordionInitialized) return;
      title.dataset.accordionInitialized = 'true';

      // Get content by aria-controls if already linked
      let contentId = title.getAttribute('aria-controls');
      let content = contentId ? document.getElementById(contentId) : null;

      // Fallback if not found or not valid
      if (!content || !content.classList.contains('accordion-content')) {
        content = title.nextElementSibling;
        const newId = `accordion-${Math.random().toString(36).substr(2, 9)}`;
        content.id = newId;
        title.setAttribute('aria-controls', newId);
      }

      // Set accessible attributes
      title.setAttribute('tabindex', '0');
      title.setAttribute('role', 'button');

      const isActive = title.classList.contains('active');
      title.setAttribute('aria-expanded', isActive);
      content.setAttribute('aria-hidden', !isActive);

      const toggleAccordion = () => {
        const nowActive = title.classList.toggle('active');
        title.setAttribute('aria-expanded', nowActive);
        content.setAttribute('aria-hidden', !nowActive);
      };

      // Interaction handlers
      title.addEventListener('click', toggleAccordion);
      title.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
          e.preventDefault();
          toggleAccordion();
        }
      });
    });
  });
};


document.addEventListener('DOMContentLoaded', function () {
  const hasAccordion = () => document.querySelector('.accordion-section');
  const isRelevantPage = () => {
    const path = window.location.pathname;
    return path.includes('/products/') || path.includes('/blogs/');
  };

  if (!isRelevantPage() || !hasAccordion()) return;

  window.initAccordion();

  // Debounced reinits on input/change events
  let debounce;
  const debouncedInit = () => {
    if (!hasAccordion()) return;
    clearTimeout(debounce);
    debounce = setTimeout(() => {
      window.initAccordion();
    }, 100);
  };

  document.body.addEventListener('change', (e) => {
    if (e.target.closest('.product-form')) debouncedInit();
  });

  document.body.addEventListener('input', (e) => {
    if (e.target.closest('.product-form')) debouncedInit();
  });

  // MutationObserver for dynamic content (e.g., translations)
  const observeTargets = document.querySelectorAll('.rte.text--pull, .product__description, main, [data-accordion]');

  observeTargets.forEach(target => {
    const observer = new MutationObserver(() => {
      if (!hasAccordion()) return;
      window.initAccordion();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
});